import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { visibleSections } from "./navConfig";
import { NavList } from "./NavList";
import { Brand } from "./Brand";
import { Button } from "@/components/ui/button";
import { PanelLeftClose, PanelLeftOpen, ShieldCheck, ChevronRight } from "lucide-react";
import { Logo } from "@/components/nav/Brand";

const UserCard = ({ user, collapsed }) => (
  <NavLink to="/profile" data-testid="sidebar-user-card"
    className="mt-auto flex items-center gap-3 rounded-2xl bg-card border border-border p-3 shadow-premium hover:-translate-y-px transition-transform">
    <div className="h-9 w-9 rounded-full navy-strip text-white flex items-center justify-center text-sm font-semibold shrink-0">
      {user?.name?.[0]?.toUpperCase() || "U"}
    </div>
    {!collapsed && (
      <>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-semibold truncate">{user?.name}</div>
          <div className="text-[11px] text-muted-foreground truncate">{user?.email}</div>
        </div>
        <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0" />
      </>
    )}
  </NavLink>
);

export const SidebarContent = ({ collapsed = false, onNavigate, onToggle }) => {
  const { user, t } = useApp();
  const navigate = useNavigate();
  const sections = visibleSections(t, user?.pro_mode);

  return (
    <div className="flex h-full flex-col gap-6 p-4">
      <div className={`flex items-center ${collapsed ? "justify-center" : "justify-between"}`}>
        <button onClick={() => { navigate("/"); onNavigate?.(); }} className="text-start" data-testid="sidebar-brand">
          {collapsed ? (
            <Logo className="h-12 w-auto" />
          ) : <Brand />}
        </button>
        {onToggle && !collapsed && (
          <Button variant="ghost" size="icon" onClick={onToggle} data-testid="sidebar-collapse"
            className="hidden lg:inline-flex text-muted-foreground">
            <PanelLeftClose className="h-4 w-4" />
          </Button>
        )}
      </div>

      {collapsed && onToggle && (
        <Button variant="ghost" size="icon" onClick={onToggle} data-testid="sidebar-expand"
          className="mx-auto text-muted-foreground">
          <PanelLeftOpen className="h-4 w-4" />
        </Button>
      )}

      <div className="flex-1 overflow-y-auto no-scrollbar">
        <NavList sections={sections} collapsed={collapsed} onNavigate={onNavigate} />
        {user?.role === "admin" && (
          <NavLink to="/admin" onClick={onNavigate} data-testid="sidebar-admin-link"
            className="mt-6 flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-card/60 transition-colors">
            <ShieldCheck className="h-[18px] w-[18px] shrink-0" />
            {!collapsed && <span>{t("nav_admin")}</span>}
          </NavLink>
        )}
      </div>

      <UserCard user={user} collapsed={collapsed} />
    </div>
  );
};
